export class AppInsightCustomerChange {
    userId?: string = "";
    searchTerm?: string = "";
    branchNumber?: string = "";
    source?: string = "";
    products?: any = null;
    cartDetails?: string;
    previousRewardNumber?: string = "";
    previousCustomerName?: string = "";
    currentRewardNumber?: string = "";
    currentCustomerName?: string = "";
}
